var _module = require('./index.js');
var hoiRates = require('./hoi-rates');
// var config = require('../../../../config');

_module.factory('mortgageCalculatorService', [
    '$http',
    '$q',
    function($http, $q) {
        var isReadyDeferred = $q.defer();
        var interestRates = {
            '30': undefined,
            '15': undefined,
            '51': undefined // 5-1 ARM
        };

        _fetchInterestRates()
            .finally(function() {
                isReadyDeferred.resolve();
            });

        function _fetchInterestRates() {
            var apiUrl = "https://www.listreports.com";
            var promises = ['30-Yr FRM', '15-Yr FRM', '5/1-Yr ARM'].reduce(function (result, type) {
                var num = type.replace(/([^0-9])/gi, '');
                result[num] = $http.get(apiUrl + '/v1/mortgage-rates/' + encodeURIComponent(type));

                return result;
            }, {});
            return $q.all(promises)
                .then(function (response) {
                    interestRates['30'] = response['30'].data.data;
                    interestRates['15'] = response['15'].data.data;
                    interestRates['51'] = response['51'].data.data;

                })
                .catch(function onError(err) {
                });
        }

        var MortgageCalculator = function(data) {
            this.getHOIRate = function getHOIRate() {
                if (data.state) {
                    return Math.round(hoiRates[data.state.abbr.toLowerCase()] * 100) / 100;
                }
            };

            this.monthlyPayment = function() {
                var payment = this.principalAndInterest();
                if(data.hoi) payment += data.hoi;
                if(data.propertyTaxes) payment += this.monthlyPropertyTaxes();
                if(data.hoaDues) payment += this.monthlyHoaDues();
                if(data.downPaymentPercentage < .2 && data.mortgageInsurance) payment += data.mortgageInsurance;

                return payment;
            };

            this.principalAndInterest = function () {
                var principal = data.homePrice - data.downPayment;
                var interestRate = data.interestRate;
                var numPayments = getNumberOfPayments();
                var interest = interestRate / 100 / 12;
                return principal * interest * (Math.pow(1 + interest, numPayments)) / (Math.pow(1 + interest, numPayments) - 1);
            };

            this.getInterestRateForLoanType = function() {
                switch (data.loanType) {
                    case '30 Year Fixed':
                        return interestRates['30'];
                    case '15 Year Fixed':
                        return interestRates['15'];
                    case '5/1 ARM':
                        return interestRates['51'];
                }
            };

            this.monthlyPropertyTaxes = function() {
                if (data.propertyTaxes) {
                    return data.propertyTaxes / 12;
                }
            };
            
            this.monthlyHoaDues = function() {
                if (data.hoaDues) {
                    if (data.hoaDuesPeriod == 'year') {
                        return data.hoaDues / 12;
                    }
                    if (data.hoaDuesPeriod == 'quarter') {
                        return data.hoaDues / 3;
                    }

                    return data.hoaDues;
                }
            };

            this.hoiValueForCurrentPercentage = function(homePrice) {
                var value = homePrice * (data.hoiPercentage / 100) / 12;
                return Math.round(value * 100) / 100;
            };


            function getNumberOfPayments() {
                switch (data.loanType) {
                    case '30 Year Fixed':
                        return 30 * 12;

                    case '15 Year Fixed':
                        return 15 * 12;

                    case '5/1 ARM':
                        return 30 * 12;
                }
            }
        };

        return {
            isReadyPromise: isReadyDeferred.promise,
            Calculator: MortgageCalculator
        };
    }
]);
